import { render } from "./EstrattiConto.vue?vue&type=template&id=5a3ed38c"
import script from "./EstrattiConto.vue?vue&type=script&lang=js"
export * from "./EstrattiConto.vue?vue&type=script&lang=js"

import "./EstrattiConto.vue?vue&type=style&index=0&id=5a3ed38c&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__